import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { getToken } from "@/lib/api";
import LoginGate from "@/pages/LoginGate";
import Dashboard from "@/pages/Dashboard";

function App() {
  const [authed, setAuthed] = useState(!!getToken());

  useEffect(() => {
    const out = () => setAuthed(false);
    window.addEventListener("mdb-logout", out);
    return () => window.removeEventListener("mdb-logout", out);
  }, []);

  return (
    <div className="dark min-h-screen bg-[#0B0F17] grain">
      {authed ? <Dashboard onLogout={() => setAuthed(false)} /> : <LoginGate onDone={() => setAuthed(true)} />}
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
